import { useEffect, useState } from 'react';
import { api, type HealthResp, type OrgsResp } from '../api';
import { LoginAsCamp } from '../lib';

// Read-only cross-stack overview — surface health probes + the platform org registry. A registry org
// that is a commerce camp (external_ref 'commerce:<id>') links to the storefront acting as that camp.
export function DashboardsPanel() {
  const [orgs, setOrgs] = useState<OrgsResp | null>(null);
  const [health, setHealth] = useState<HealthResp | null>(null);
  useEffect(() => { api.orgs().then(setOrgs).catch(() => {}); api.health().then(setHealth).catch(() => {}); }, []);

  return (
    <div className="stack">
      <h1>Cross-stack overview</h1>
      <section className="cards">
        {(health?.results ?? []).map((r) => (
          <div key={r.surface} className={`stat ${r.ok ? 'up' : 'down'}`}>
            <div className="stat-k">{r.surface}</div>
            <div className="stat-v">{r.ok ? 'up' : 'down'}</div>
            <div className="stat-sub">{r.status || '—'} · {r.ms}ms</div>
          </div>
        ))}
        {orgs && (
          <div className="stat">
            <div className="stat-k">camp accounts</div>
            <div className="stat-v">{orgs.totals.orgs}</div>
            <div className="stat-sub">{orgs.totals.viaService} via service · {orgs.totals.viaMember} via member</div>
          </div>
        )}
      </section>
      <section className="card">
        <h2>Org registry</h2>
        <table>
          <thead><tr><th>Camp account</th><th>Slug</th><th className="num">Members</th><th>Origin</th><th>External ref</th><th>Storefront</th></tr></thead>
          <tbody>
            {(orgs?.rows ?? []).map((o) => (
              <tr key={o.id}><td>{o.name}</td><td className="mono">{o.slug}</td><td className="num">{o.members}</td><td>{o.created_via ?? '—'}</td><td className="mono">{o.external_ref ?? '—'}</td><td><LoginAsCamp orgId={o.commerce_org_id} name={o.name} /></td></tr>
            ))}
          </tbody>
        </table>
        {!orgs && <p className="loading">Loading…</p>}
      </section>
    </div>
  );
}
